import React from 'react';
import {Image} from 'antd-mobile';
import {normalizeGamePush, isOtherGame} from '@utils/game';
import {getGamePicUrl, GamePicType} from '@/components/utils/utils';

export function SearchResultItem(props: any) {
  const imageCandidates = React.useMemo(() => {
    const source = typeof props.source === 'string' ? props.source.trim() : '';
    const tripartiteUniqueness =
      typeof props.tripartiteUniqueness === 'string'
        ? props.tripartiteUniqueness.trim()
        : '';
    const cdnImage =
      source && tripartiteUniqueness
        ? getGamePicUrl(GamePicType.V_RECTANGLE, source, tripartiteUniqueness)
        : '';

    return Array.from(
      new Set(
        [cdnImage, props.otherUrl, props.gamePic]
          .map(imageUrl =>
            typeof imageUrl === 'string' ? imageUrl.trim() : imageUrl,
          )
          .filter(Boolean),
      ),
    );
  }, [props.source, props.tripartiteUniqueness, props.otherUrl, props.gamePic]);
  const [imageIndex, setImageIndex] = React.useState(0);
  const imageCandidatesSignature = imageCandidates.join('|');
  const imageUrl = imageCandidates[imageIndex] || '';

  React.useEffect(() => {
    setImageIndex(0);
  }, [imageCandidatesSignature]);

  const handleToGame = () => {
    const gameUrl = props.gameUrlV2 || props.gameUrl;
    normalizeGamePush(props.id, {
      gameUrl,
      gameName: props.name,
      otherGame: isOtherGame(gameUrl),
    });
  };
  return (
    <div className="rounded-lg overflow-hidden" onClick={handleToGame}>
      <Image
        className="aspect-[112/156] bg-cyan-50"
        src={imageUrl}
        onError={() =>
          setImageIndex(prev =>
            prev < imageCandidates.length - 1 ? prev + 1 : prev,
          )
        }
      />
    </div>
  );
}
